import {t} from 'i18next';
import AurPopup from '../../../../common/aur-popup/AurPopup';
import {Box, Typography} from '@mui/material';
import {FileCatalystModalType} from '../../../../../types/upload-new-eviidence/evidenceSourceTypes';

interface FileCatalystPopUpModalProps {
  type: FileCatalystModalType;
  isShow: boolean;
  onClose?: () => void;
  onYes?: () => void;
}

const FileCatalystPopUpModal = ({
  type,
  isShow,
  onClose,
  onYes,
}: FileCatalystPopUpModalProps) => {
  const closeTapped = () => {
    onClose?.();
  };

  const yesTapped = () => {
    onYes?.();
  };

  const heading = (() => {
    switch (type) {
      case 'leave':
        return t('fileCatalyst.leaveScreenModal.title');
      case 'cancelUpload':
        return t('common.cancelUploadPopup.heading');
      default:
        return t('fileCatalyst.removeFileModal.title');
    }
  })();

  const content = (() => {
    switch (type) {
      case 'leave':
        return t('fileCatalyst.leaveScreenModal.content');
      case 'cancelUpload':
        return t('common.cancelUploadPopup.content');
      default:
        return t('fileCatalyst.removeFileModal.content');
    }
  })();

  const okLabel = (() => {
    switch (type) {
      case 'leave':
        return t('fileCatalyst.leaveScreenModal.leave');
      case 'cancelUpload':
        return t('common.cancelUploadPopup.buttonYes');
      default:
        return t('common.yes');
    }
  })();

  return (
    <AurPopup
      className="file-catalyst-pop-up-modal"
      onCancel={closeTapped}
      onOk={yesTapped}
      open={isShow}
      popupHeading={heading}
      showPopupHeading={true}
      showPopupTitle={true}
      showCloseIcon={type === 'cancelUpload' ? false : true}
      popupTitle={
        type === 'cancelUpload' ? t('common.cancelUploadPopup.title') : ''
      }
      closeIconHint={t('fileCatalyst.leaveScreenModal.closeHint')}
      popupContent={
        <Box>
          <Typography
            tabIndex={0}
            className="typo-text body2_size description-text"
          >
            {content}
          </Typography>
        </Box>
      }
      labelActionCancel={
        type === 'cancelUpload'
          ? t('common.cancelUploadPopup.buttonStay')
          : t('buttons.close')
      }
      labelActionOk={okLabel}
      contentType="element"
    />
  );
};

export {FileCatalystPopUpModal};
